export default {
  // ============ WAREHOUSE ============
  'warehouse.category': 'Entrepôt',
  'warehouse.shortTitle': 'Guide de l’entrepôt USFans',
  'warehouse.readTime': '8 min de lecture',
  'warehouse.toc': 'Table des matières',
  'warehouse.h1': 'Entrepôt USFans : guide complet du stockage, de l’inspection et de l’expédition',
  'warehouse.lead': 'Découvrez comment fonctionne un entrepôt USFans, ce qu’impliquent le stockage et l’inspection, et comment les articles arrivent jusqu’à vous.',
  'warehouse.s1.title': 'Qu’est-ce qu’un entrepôt USFans ?',
  'warehouse.s1.p1': 'Un entrepôt USFans est une installation où les articles achetés sont reçus, stockés et préparés pour l’expédition. Il sert de point central avant l’envoi.',
  'warehouse.s1.p2': 'Les entrepôts permettent de regrouper plusieurs achats de différents vendeurs en un seul envoi, ce qui peut réduire l’effort et le coût.',
  'warehouse.s2.title': 'Comment fonctionne le stockage',
  'warehouse.s2.p1': 'À l’arrivée, chaque article est enregistré, étiqueté et rangé. Chaque colis est suivi pour pouvoir être retrouvé rapidement au moment de l’envoi.',
  'warehouse.s2.p2': 'Les durées et politiques de stockage peuvent varier ; il est utile de savoir combien de temps les articles peuvent rester et si des frais s’appliquent.',
  'warehouse.s3.title': 'Inspection et regroupement',
  'warehouse.s3.p1': 'De nombreux entrepôts proposent une inspection facultative, où le personnel vérifie l’état d’un article ou confirme le contenu du colis.',
  'warehouse.s3.p2': 'Le regroupement combine plusieurs petits colis en une seule boîte, ce qui réduit souvent le nombre d’envois et le coût total.',
  'warehouse.s4.title': 'Expédition depuis l’entrepôt',
  'warehouse.s4.p1': 'Une fois prêts, les articles sont préparés pour la méthode d’expédition choisie. Étiquettes, documents douaniers et emballage sont gérés avant le départ.',
  'warehouse.s4.p2': 'Le délai final dépend du pays de destination, du transporteur et de la vitesse choisie.',
  'warehouse.s5.title': 'Entrepôt vs expédition directe',
  'warehouse.s5.p1': 'Le tableau ci-dessous compare l’utilisation d’un entrepôt et l’expédition directe pour montrer les principales différences.',
  'warehouse.table.c1': 'Aspect',
  'warehouse.table.c2': 'Entrepôt',
  'warehouse.table.c3': 'Expédition directe',
  'warehouse.table.c4': 'Idéal pour',
  'warehouse.table.r1c1': 'Plusieurs commandes',
  'warehouse.table.r1c2': 'Peut regrouper',
  'warehouse.table.r1c3': 'Envoyées séparément',
  'warehouse.table.r1c4': 'Économies combinées',
  'warehouse.table.r2c1': 'Inspection',
  'warehouse.table.r2c2': 'Souvent disponible',
  'warehouse.table.r2c3': 'Généralement non',
  'warehouse.table.r2c4': 'Confiance accrue',
  'warehouse.table.r3c1': 'Durée de stockage',
  'warehouse.table.r3c2': 'Conserve les articles',
  'warehouse.table.r3c3': 'Aucune conservation',
  'warehouse.table.r3c4': 'Expédition différée',
  'warehouse.table.r4c1': 'Complexité',
  'warehouse.table.r4c2': 'Plus d’étapes',
  'warehouse.table.r4c3': 'Moins d’étapes',
  'warehouse.table.r4c4': 'Besoins différents',
  'warehouse.s6.title': 'Frais et délais de l’entrepôt',
  'warehouse.s6.p1': 'Les services d’entrepôt peuvent impliquer des frais de stockage, de regroupement, d’inspection ou de réemballage. Ils varient, vérifiez donc le tarif actuel.',
  'warehouse.s6.p2': 'Le délai dépend aussi de la rapidité de traitement des colis et de l’activité de l’entrepôt. Prévoyez une marge pour éviter les retards.',
  'warehouse.s7.title': 'Sécurité de l’entrepôt',
  'warehouse.s7.p1': 'N’utilisez que des services d’entrepôt de confiance et vérifiez toujours l’adresse et les détails d’expédition avant de confirmer.',
  'warehouse.s7.p2': 'Méfiez-vous des demandes de paiement hors plateforme officielle et conservez les numéros de suivi.',
  'warehouse.conclusion.title': 'En résumé',
  'warehouse.conclusion.p1': 'Un entrepôt USFans peut rendre les achats multiples plus pratiques en stockant, inspectant et regroupant les articles avant l’envoi.',
  'warehouse.conclusion.p2': 'Vérifiez toujours les frais, politiques et pratiques de sécurité pour utiliser ces services en confiance.',
  'warehouse.cta': 'Explorer la boutique complète',
  'warehouse.backHome': 'Retour à l’accueil',

  // ============ LEGIT ============
  'legit.category': 'Légitimité',
  'legit.shortTitle': 'USFans est-il légitime ?',
  'legit.readTime': '7 min de lecture',
  'legit.toc': 'Table des matières',
  'legit.h1': 'USFans est-il légitime ? Sécurité, confiance et points à vérifier',
  'legit.lead': 'Comprenez comment évaluer la légitimité d’USFans, quels signaux de confiance rechercher et comment vous protéger.',
  'legit.s1.title': 'Que signifie la légitimité ici ?',
  'legit.s1.p1': 'La légitimité désigne la transparence d’un service, le respect de ses promesses et la protection de ses utilisateurs. C’est une question de confiance.',
  'legit.s1.p2': 'Aucune ressource indépendante ne doit affirmer qu’un service tiers est totalement sûr. Concentrez-vous sur des signaux vérifiables.',
  'legit.s2.title': 'Signaux de confiance à rechercher',
  'legit.s2.p1': 'Des coordonnées claires, des politiques transparentes, des informations d’entreprise vérifiables et un support réactif sont des signes positifs.',
  'legit.s2.p2': 'Les expériences réelles et les discussions de tiers aident aussi, mais traitez les avis individuels avec prudence.',
  'legit.s3.title': 'Signaux d’alerte courants',
  'legit.s3.p1': 'La pression à agir vite, les demandes de paiement hors canaux officiels et les politiques vagues sont des signaux d’alerte courants.',
  'legit.s3.p2': 'Les promesses trop belles pour être vraies ou les demandes de mots de passe doivent toujours être traitées avec prudence.',
  'legit.s4.title': 'Comment vérifier de façon indépendante',
  'legit.s4.p1': 'Consultez les sources officielles, lisez les conditions et confirmez les détails importants comme les prix et l’expédition avant de vous engager.',
  'legit.s4.p2': 'La vérification indépendante est la meilleure protection, car les informations de tiers peuvent changer.',
  'legit.s5.title': 'Facteurs de confiance comparés',
  'legit.s5.p1': 'Le tableau ci-dessous résume les facteurs clés pour juger si un service semble digne de confiance.',
  'legit.table.c1': 'Facteur',
  'legit.table.c2': 'Signe positif',
  'legit.table.c3': 'Signe d’alerte',
  'legit.table.c4': 'Que faire',
  'legit.table.r1c1': 'Contact',
  'legit.table.r1c2': 'Clair et joignable',
  'legit.table.r1c3': 'Manquant ou vague',
  'legit.table.r1c4': 'Vérifiez vous-même',
  'legit.table.r2c1': 'Politiques',
  'legit.table.r2c2': 'Conditions transparentes',
  'legit.table.r2c3': 'Conditions cachées',
  'legit.table.r2c4': 'Lisez attentivement',
  'legit.table.r3c1': 'Paiements',
  'legit.table.r3c2': 'Canaux officiels',
  'legit.table.r3c3': 'Demandes externes',
  'legit.table.r3c4': 'Évitez et signalez',
  'legit.table.r4c1': 'Support',
  'legit.table.r4c2': 'Aide réactive',
  'legit.table.r4c3': 'Aucune réponse',
  'legit.table.r4c4': 'Testez avant d’acheter',
  'legit.s6.title': 'Sécurité des paiements et du compte',
  'legit.s6.p1': 'Ne payez que par des canaux officiels et sécurisés et ne partagez jamais votre mot de passe ni vos codes de vérification.',
  'legit.s6.p2': 'Utilisez des mots de passe forts et uniques et activez les options de sécurité supplémentaires proposées.',
  'legit.s7.title': 'Considérations de confidentialité',
  'legit.s7.p1': 'Soyez attentif aux informations personnelles que vous partagez et évitez de saisir des données sensibles sur des pages inconnues.',
  'legit.s7.p2': 'Cette ressource indépendante ne demande pas vos informations personnelles pour naviguer.',
  'legit.conclusion.title': 'En résumé',
  'legit.conclusion.p1': 'Déterminer la légitimité exige une recherche équilibrée et indépendante, sans se fier à une seule source.',
  'legit.conclusion.p2': 'Restez prudent, vérifiez par vous-même et utilisez les canaux officiels.',
  'legit.cta': 'Explorer la boutique complète',
  'legit.backHome': 'Retour à l’accueil',

  // ============ CREATOR DIRECTORY ============
  'creator.category': 'Créateurs',
  'creator.shortTitle': 'Guide du répertoire de créateurs USFans',
  'creator.readTime': '7 min de lecture',
  'creator.toc': 'Table des matières',
  'creator.h1': 'Répertoire de créateurs USFans : comment trouver et parcourir les créateurs',
  'creator.lead': 'Apprenez comment fonctionnent les répertoires de créateurs, comment trouver des créateurs précis et parcourir les profils efficacement.',
  'creator.s1.title': 'Qu’est-ce qu’un répertoire de créateurs ?',
  'creator.s1.p1': 'Un répertoire de créateurs est une liste structurée, organisée par catégorie, nom ou statut, pour faciliter la découverte.',
  'creator.s1.p2': 'Les répertoires permettent de parcourir de nombreux profils au même endroit au lieu de chercher page par page.',
  'creator.s2.title': 'Comment parcourir le répertoire',
  'creator.s2.p1': 'Commencez par une catégorie qui vous intéresse, puis consultez les entrées pour comprendre ce que propose chaque créateur.',
  'creator.s2.p2': 'Les filtres et la recherche peuvent affiner les résultats par nom ou sujet, pour vous concentrer sur les profils pertinents.',
  'creator.s3.title': 'Lire un profil de créateur',
  'creator.s3.p1': 'Un profil comprend généralement le nom, la catégorie, un lien ou une référence, le statut et la date de mise à jour.',
  'creator.s3.p2': 'Concentrez-vous sur les entrées actives et récemment mises à jour, et vérifiez les détails importants.',
  'creator.s4.title': 'Conseils de découverte',
  'creator.s4.p1': 'Commencez large puis affinez. Explorez d’abord une catégorie, puis cherchez des créateurs qui correspondent à vos intérêts.',
  'creator.s4.p2': 'Prendre des notes pendant la navigation aide à comparer les créateurs et à revenir aux plus prometteurs.',
  'creator.s5.title': 'Répertoire vs tableur',
  'creator.s5.p1': 'Le tableau ci-dessous compare un répertoire à une vue de tableur pour clarifier quand chacun est plus utile.',
  'creator.table.c1': 'Aspect',
  'creator.table.c2': 'Répertoire',
  'creator.table.c3': 'Tableur',
  'creator.table.c4': 'Idéal pour',
  'creator.table.r1c1': 'Présentation',
  'creator.table.r1c2': 'Pages par catégorie',
  'creator.table.r1c3': 'Lignes et colonnes',
  'creator.table.r1c4': 'Navigation différente',
  'creator.table.r2c1': 'Découverte',
  'creator.table.r2c2': 'Parcourir par thème',
  'creator.table.r2c3': 'Parcourir et comparer',
  'creator.table.r2c4': 'Les deux utiles',
  'creator.table.r3c1': 'Mise à jour',
  'creator.table.r3c2': 'Dépend de l’entretien',
  'creator.table.r3c3': 'Dépend de l’entretien',
  'creator.table.r3c4': 'Vérifiez manuellement',
  'creator.table.r4c1': 'Courbe d’apprentissage',
  'creator.table.r4c2': 'Très faible',
  'creator.table.r4c3': 'Faible',
  'creator.table.r4c4': 'Facile à démarrer',
  'creator.s6.title': 'Qualité des données et vérification',
  'creator.s6.p1': 'Les répertoires communautaires peuvent contenir des entrées obsolètes ; vérifiez toujours les liens et détails par vous-même.',
  'creator.s6.p2': 'Traitez avec prudence tout lien demandant des informations personnelles ou un paiement, et privilégiez les sources officielles.',
  'creator.s7.title': 'Confidentialité pendant la navigation',
  'creator.s7.p1': 'Évitez de partager des données sensibles sur des pages inconnues et utilisez les sites officiels pour comptes et achats.',
  'creator.s7.p2': 'Cette ressource indépendante vous permet de parcourir guides et répertoires sans fournir de données personnelles.',
  'creator.conclusion.title': 'En résumé',
  'creator.conclusion.p1': 'Un répertoire de créateurs est un point de départ pratique pour découvrir et comparer des créateurs.',
  'creator.conclusion.p2': 'Associez la navigation du répertoire à une vérification indépendante pour une image plus précise.',
  'creator.cta': 'Explorer la boutique complète',
  'creator.backHome': 'Retour à l’accueil',

  // ============ SPREADSHEET SEARCH ============
  'search.category': 'Recherche',
  'search.shortTitle': 'Guide de recherche dans le tableur USFans',
  'search.readTime': '6 min de lecture',
  'search.toc': 'Table des matières',
  'search.h1': 'Recherche dans le tableur USFans : trouver ce dont vous avez besoin rapidement',
  'search.lead': 'Découvrez des conseils pratiques pour chercher dans un tableur USFans, utiliser les filtres et affiner rapidement les résultats.',
  'search.s1.title': 'Pourquoi la recherche est importante',
  'search.s1.p1': 'Un tableur bien organisé peut contenir de nombreuses entrées ; savoir chercher vous aide à trouver ce qu’il vous faut sans tout parcourir.',
  'search.s1.p2': 'De bonnes habitudes de recherche transforment une grande ressource en outil rapide et ciblé.',
  'search.s2.title': 'Commencer par les catégories',
  'search.s2.p1': 'Commencez par choisir la catégorie qui correspond le mieux à ce que vous cherchez, puis explorez les entrées qu’elle contient.',
  'search.s2.p2': 'Cette première étape simple élimine la plupart des résultats non pertinents.',
  'search.s3.title': 'Utiliser filtres et mots-clés',
  'search.s3.p1': 'Utilisez les filtres pour affiner par nom, statut ou date, et des mots-clés courts et précis plutôt que de longues phrases.',
  'search.s3.p2': 'Si un mot-clé est trop précis et ne renvoie rien, essayez un terme plus large puis affinez progressivement.',
  'search.s4.title': 'Lire les résultats',
  'search.s4.p1': 'Prêtez attention au statut et aux informations de mise à jour pour privilégier les entrées actives et récentes.',
  'search.s4.p2': 'Ouvrez les résultats prometteurs dans un nouvel onglet pour comparer plusieurs entrées sans perdre votre place.',
  'search.s5.title': 'Approches de recherche comparées',
  'search.s5.p1': 'Le tableau ci-dessous compare les approches de recherche courantes pour vous aider à choisir la bonne.',
  'search.table.c1': 'Approche',
  'search.table.c2': 'Fonctionnement',
  'search.table.c3': 'Point fort',
  'search.table.c4': 'À utiliser quand',
  'search.table.r1c1': 'Par catégorie',
  'search.table.r1c2': 'Parcourir un groupe',
  'search.table.r1c3': 'Découverte large',
  'search.table.r1c4': 'Explorer des thèmes',
  'search.table.r2c1': 'Par mot-clé',
  'search.table.r2c2': 'Faire correspondre un terme',
  'search.table.r2c3': 'Affiner vite',
  'search.table.r2c4': 'Noms connus',
  'search.table.r3c1': 'Par statut',
  'search.table.r3c2': 'Filtrer les actifs',
  'search.table.r3c3': 'Résultats frais',
  'search.table.r3c4': 'Prioriser les mises à jour',
  'search.table.r4c1': 'Par date',
  'search.table.r4c2': 'Trier par mise à jour',
  'search.table.r4c3': 'Récent uniquement',
  'search.table.r4c4': 'Vérifier la fraîcheur',
  'search.s6.title': 'Erreurs de recherche courantes',
  'search.s6.p1': 'Des mots-clés trop précis, l’oubli des filtres et l’ignorance du statut sont des erreurs courantes qui ralentissent la recherche.',
  'search.s6.p2': 'Commencez large, appliquez les filtres progressivement et vérifiez toujours la date de mise à jour.',
  'search.s7.title': 'Sécurité de la recherche',
  'search.s7.p1': 'Méfiez-vous des résultats redirigeant vers des pages inconnues et n’entrez jamais de données personnelles ou de paiement sur des sites non fiables.',
  'search.s7.p2': 'Utilisez des sources connues et officielles et vérifiez les détails importants par vous-même.',
  'search.conclusion.title': 'En résumé',
  'search.conclusion.p1': 'Une recherche efficace transforme un tableur USFans en ressource rapide et ciblée.',
  'search.conclusion.p2': 'Utilisez ensemble catégories, filtres et statuts pour trouver ce qu’il vous faut vite et en sécurité.',
  'search.cta': 'Explorer la boutique complète',
  'search.backHome': 'Retour à l’accueil',

  // ============ SAFETY ============
  'safety.category': 'Sécurité',
  'safety.shortTitle': 'Centre de sécurité USFans',
  'safety.readTime': '8 min de lecture',
  'safety.toc': 'Table des matières',
  'safety.h1': 'Centre de sécurité USFans : protégez votre compte et vos paiements',
  'safety.lead': 'Des conseils pratiques sur la sécurité du compte, des paiements, la prévention du phishing et la protection de la vie privée.',
  'safety.s1.title': 'Pourquoi la sécurité compte',
  'safety.s1.p1': 'Les services en ligne impliquent des informations personnelles et des paiements ; des habitudes simples protègent votre compte et votre argent.',
  'safety.s1.p2': 'La plupart des problèmes peuvent être évités avec quelques précautions simples et régulières.',
  'safety.s2.title': 'Les bases de la sécurité du compte',
  'safety.s2.p1': 'Utilisez un mot de passe fort et unique pour chaque service et ne réutilisez jamais le même mot de passe.',
  'safety.s2.p2': 'Activez les options de sécurité supplémentaires proposées et gardez vos informations de récupération à jour.',
  'safety.s3.title': 'Sécurité des paiements',
  'safety.s3.p1': 'Ne payez que par des canaux officiels et sécurisés et confirmez toujours les détails avant de finaliser.',
  'safety.s3.p2': 'Ne partagez jamais vos informations de paiement, codes de vérification ou mots de passe avec un contact inattendu.',
  'safety.s4.title': 'Prévention du phishing et des arnaques',
  'safety.s4.p1': 'Les messages de phishing imitent souvent un vrai service et vous poussent à agir vite. Vérifiez l’expéditeur avant de répondre.',
  'safety.s4.p2': 'Méfiez-vous des offres trop belles pour être vraies et des demandes de déplacement des paiements vers des canaux non officiels.',
  'safety.s5.title': 'Risque vs protection',
  'safety.s5.p1': 'Le tableau ci-dessous associe les risques courants à des protections simples.',
  'safety.table.c1': 'Risque',
  'safety.table.c2': 'Exemple',
  'safety.table.c3': 'Protection',
  'safety.table.c4': 'Priorité',
  'safety.table.r1c1': 'Vol de compte',
  'safety.table.r1c2': 'Mot de passe faible',
  'safety.table.r1c3': 'Mot de passe unique',
  'safety.table.r1c4': 'Élevée',
  'safety.table.r2c1': 'Fraude au paiement',
  'safety.table.r2c2': 'Demande externe',
  'safety.table.r2c3': 'Canaux officiels',
  'safety.table.r2c4': 'Élevée',
  'safety.table.r3c1': 'Phishing',
  'safety.table.r3c2': 'Message faux',
  'safety.table.r3c3': 'Vérifier l’expéditeur',
  'safety.table.r3c4': 'Élevée',
  'safety.table.r4c1': 'Exposition des données',
  'safety.table.r4c2': 'Partage excessif',
  'safety.table.r4c3': 'Limiter le partage',
  'safety.table.r4c4': 'Moyenne',
  'safety.s6.title': 'Vérification des données',
  'safety.s6.p1': 'Vérifiez toujours les liens, prix et politiques directement sur le site officiel avant de décider ou de payer.',
  'safety.s6.p2': 'Les informations de tiers peuvent changer, la vérification indépendante est donc essentielle.',
  'safety.s7.title': 'Protection de la vie privée',
  'safety.s7.p1': 'Soyez attentif à ce que vous partagez en ligne et évitez de saisir des données sensibles sur des pages inconnues.',
  'safety.s7.p2': 'Cette ressource indépendante ne demande pas vos informations personnelles pour naviguer.',
  'safety.conclusion.title': 'En résumé',
  'safety.conclusion.p1': 'Quelques habitudes de sécurité régulières protègent efficacement compte, paiements et vie privée.',
  'safety.conclusion.p2': 'Restez prudent, vérifiez par vous-même et utilisez les canaux officiels.',
  'safety.cta': 'Explorer la boutique complète',
  'safety.backHome': 'Retour à l’accueil',

  // ============ FAQ ============
  'faq.category': 'FAQ',
  'faq.shortTitle': 'FAQ complète USFans',
  'faq.readTime': '6 min de lecture',
  'faq.toc': 'Table des matières',
  'faq.h1': 'FAQ USFans : réponses aux questions courantes',
  'faq.lead': 'Des réponses claires aux questions les plus courantes sur USFans, son tableur, l’expédition, les coupons et la sécurité.',
  'faq.s1.title': 'Premiers pas',
  'faq.s1.p1': 'Si vous découvrez USFans, commencez par comprendre ce que c’est et comment ses ressources sont organisées.',
  'faq.s1.p2': 'Les guides de ce site expliquent les bases étape par étape pour vous donner une vision claire rapidement.',
  'faq.s2.title': 'À propos du tableur',
  'faq.s2.p1': 'Le tableur USFans est une ressource organisée qui rassemble listes de créateurs, catégories et liens utiles.',
  'faq.s2.p2': 'Il facilite la découverte et la comparaison par rapport à une recherche dans de nombreuses pages.',
  'faq.s3.title': 'À propos de l’expédition',
  'faq.s3.p1': 'Les frais d’expédition dépendent de facteurs comme la destination, le poids, le transporteur et la vitesse, et peuvent changer.',
  'faq.s3.p2': 'Confirmez toujours les détails d’expédition actuels sur le site officiel avant de commander.',
  'faq.s4.title': 'À propos des coupons et réductions',
  'faq.s4.p1': 'Les coupons et codes peuvent changer ou expirer ; vérifiez les offres actuelles dans la boutique officielle.',
  'faq.s4.p2': 'Utilisez uniquement des codes de sources fiables et évitez ceux qui semblent suspects ou trop beaux.',
  'faq.s5.title': 'Questions courantes comparées',
  'faq.s5.p1': 'Le tableau ci-dessous résume quelques questions courantes et leurs réponses courtes.',
  'faq.table.c1': 'Question',
  'faq.table.c2': 'Réponse courte',
  'faq.table.c3': 'Guide associé',
  'faq.table.c4': 'Où vérifier',
  'faq.table.r1c1': 'Qu’est-ce que USFans ?',
  'faq.table.r1c2': 'Une ressource d’achat',
  'faq.table.r1c3': 'Guide débutant',
  'faq.table.r1c4': 'Site officiel',
  'faq.table.r2c1': 'Comment calcule-t-on l’expédition ?',
  'faq.table.r2c2': 'Plusieurs facteurs',
  'faq.table.r2c3': 'Guide d’expédition',
  'faq.table.r2c4': 'Site officiel',
  'faq.table.r3c1': 'Les coupons sont-ils réels ?',
  'faq.table.r3c2': 'Varie selon l’offre',
  'faq.table.r3c3': 'Guide des coupons',
  'faq.table.r3c4': 'Boutique officielle',
  'faq.table.r4c1': 'Est-ce sûr ?',
  'faq.table.r4c2': 'Prenez des précautions',
  'faq.table.r4c3': 'Centre de sécurité',
  'faq.table.r4c4': 'Vérification indépendante',
  'faq.s6.title': 'Dépannage',
  'faq.s6.p1': 'Si un lien ne fonctionne pas ou si une information semble obsolète, consultez le site officiel et cherchez les détails les plus récents.',
  'faq.s6.p2': 'Pour les problèmes de compte ou de paiement, contactez le support officiel uniquement par des canaux vérifiés.',
  'faq.s7.title': 'Plus d’aide',
  'faq.s7.p1': 'Parcourez les guides associés de ce site pour des explications plus approfondies.',
  'faq.s7.p2': 'Rappelez-vous qu’il s’agit d’une ressource indépendante ; confirmez toujours les détails importants.',
  'faq.conclusion.title': 'En résumé',
  'faq.conclusion.p1': 'La plupart des questions ont une réponse simple une fois que vous savez où chercher.',
  'faq.conclusion.p2': 'Utilisez ensemble les guides et les sources officielles pour des informations précises et actuelles.',
  'faq.cta': 'Explorer la boutique complète',
  'faq.backHome': 'Retour à l’accueil',

  // ============ ALTERNATIVES ============
  'alternatives.category': 'Alternatives',
  'alternatives.shortTitle': 'Alternatives à USFans',
  'alternatives.readTime': '7 min de lecture',
  'alternatives.toc': 'Table des matières',
  'alternatives.h1': 'Alternatives à USFans : comment comparer vos options',
  'alternatives.lead': 'Apprenez à évaluer les alternatives à USFans et à comparer les services selon vos besoins.',
  'alternatives.s1.title': 'Pourquoi envisager des alternatives',
  'alternatives.s1.p1': 'Différents services offrent différentes fonctions, prix et options d’expédition ; comparer peut vous aider à trouver le meilleur choix.',
  'alternatives.s1.p2': 'Comprendre ce qui compte le plus pour vous rend toute comparaison plus utile.',
  'alternatives.s2.title': 'Que comparer',
  'alternatives.s2.p1': 'Concentrez-vous sur les facteurs qui vous touchent le plus : frais d’expédition, délais, catégories et facilité d’utilisation.',
  'alternatives.s2.p2': 'Les politiques, la qualité du support et la transparence comptent aussi et en disent long sur un service.',
  'alternatives.s3.title': 'Expédition et prix',
  'alternatives.s3.p1': 'Comparez les méthodes d’expédition, les délais estimés et les frais supplémentaires, car ils affectent le coût final.',
  'alternatives.s3.p2': 'Les prix peuvent changer ; confirmez les tarifs actuels directement plutôt que de vous fier à d’anciennes comparaisons.',
  'alternatives.s4.title': 'Confiance et support',
  'alternatives.s4.p1': 'Cherchez des coordonnées claires, des politiques transparentes et un support réactif pour évaluer toute alternative.',
  'alternatives.s4.p2': 'Les avis indépendants et les discussions aident, mais vérifiez toujours les affirmations importantes.',
  'alternatives.s5.title': 'Cadre de comparaison',
  'alternatives.s5.p1': 'Le tableau ci-dessous propose un cadre simple pour comparer les services côte à côte.',
  'alternatives.table.c1': 'Facteur',
  'alternatives.table.c2': 'À vérifier',
  'alternatives.table.c3': 'Pourquoi c’est important',
  'alternatives.table.c4': 'Comment vérifier',
  'alternatives.table.r1c1': 'Expédition',
  'alternatives.table.r1c2': 'Coût et vitesse',
  'alternatives.table.r1c3': 'Affecte le prix total',
  'alternatives.table.r1c4': 'Tarifs officiels',
  'alternatives.table.r2c1': 'Catégories',
  'alternatives.table.r2c2': 'Articles disponibles',
  'alternatives.table.r2c3': 'Correspond aux besoins',
  'alternatives.table.r2c4': 'Parcourir la boutique',
  'alternatives.table.r3c1': 'Politiques',
  'alternatives.table.r3c2': 'Conditions et frais',
  'alternatives.table.r3c3': 'Éviter les surprises',
  'alternatives.table.r3c4': 'Lire les conditions',
  'alternatives.table.r4c1': 'Support',
  'alternatives.table.r4c2': 'Réactivité',
  'alternatives.table.r4c3': 'Tranquillité',
  'alternatives.table.r4c4': 'Tester le contact',
  'alternatives.s6.title': 'Éviter les biais',
  'alternatives.s6.p1': 'Chaque service a des forces et des faiblesses ; essayez de les peser objectivement.',
  'alternatives.s6.p2': 'Cherchez des tendances dans plusieurs sources et vérifiez les faits directement avant de conclure.',
  'alternatives.s7.title': 'Rester en sécurité',
  'alternatives.s7.p1': 'Appliquez les mêmes habitudes de sécurité à tout service : canaux officiels, vérification et protection du compte.',
  'alternatives.s7.p2': 'Soyez particulièrement prudent avec les alternatives que vous ne connaissez pas.',
  'alternatives.conclusion.title': 'En résumé',
  'alternatives.conclusion.p1': 'Comparer les alternatives avec soin vous aide à choisir le service le mieux adapté.',
  'alternatives.conclusion.p2': 'Concentrez-vous sur les facteurs importants et vérifiez toujours les informations actuelles.',
  'alternatives.cta': 'Explorer la boutique complète',
  'alternatives.backHome': 'Retour à l’accueil',

  // ============ SHIPPING OPTIONS ============
  'shippingopts.category': 'Expédition',
  'shippingopts.shortTitle': 'Guide des options d’expédition USFans',
  'shippingopts.readTime': '7 min de lecture',
  'shippingopts.toc': 'Table des matières',
  'shippingopts.h1': 'Options d’expédition USFans : méthodes, livraison et expédition internationale',
  'shippingopts.lead': 'Découvrez les différentes options d’expédition, comment varient les délais et ce qu’il faut savoir sur l’international.',
  'shippingopts.s1.title': 'Comprendre les options d’expédition',
  'shippingopts.s1.p1': 'Les options d’expédition diffèrent par la vitesse, le transporteur et le coût ; le bon choix dépend de l’urgence de votre commande.',
  'shippingopts.s1.p2': 'Les méthodes plus rapides coûtent généralement plus cher, tandis que les plus lentes font économiser.',
  'shippingopts.s2.title': 'Délais de livraison',
  'shippingopts.s2.p1': 'Le délai dépend de la destination, du transporteur et de la vitesse choisie, et les estimations peuvent varier.',
  'shippingopts.s2.p2': 'Vérifiez toujours les délais estimés actuels sur le site officiel avant de commander.',
  'shippingopts.s3.title': 'Expédition internationale',
  'shippingopts.s3.p1': 'Les commandes internationales peuvent impliquer douanes, droits et manutention, ce qui affecte coût et délai.',
  'shippingopts.s3.p2': 'Comprenez les règles du pays de destination et les frais éventuels pour éviter les surprises.',
  'shippingopts.s4.title': 'Choisir la bonne méthode',
  'shippingopts.s4.p1': 'Équilibrez coût, vitesse et suivi, et envisagez le regroupement si vous commandez plusieurs articles.',
  'shippingopts.s4.p2': 'Les numéros de suivi aident à suivre votre commande et à repérer rapidement les retards.',
  'shippingopts.s5.title': 'Méthodes d’expédition comparées',
  'shippingopts.s5.p1': 'Le tableau ci-dessous compare les types de méthodes d’expédition et quand chacune est un bon choix.',
  'shippingopts.table.c1': 'Méthode',
  'shippingopts.table.c2': 'Vitesse',
  'shippingopts.table.c3': 'Coût',
  'shippingopts.table.c4': 'Idéal pour',
  'shippingopts.table.r1c1': 'Standard',
  'shippingopts.table.r1c2': 'Plus lente',
  'shippingopts.table.r1c3': 'Plus bas',
  'shippingopts.table.r1c4': 'Économiser',
  'shippingopts.table.r2c1': 'Express',
  'shippingopts.table.r2c2': 'Plus rapide',
  'shippingopts.table.r2c3': 'Plus élevé',
  'shippingopts.table.r2c4': 'Commandes urgentes',
  'shippingopts.table.r3c1': 'Suivie',
  'shippingopts.table.r3c2': 'Variable',
  'shippingopts.table.r3c3': 'Modéré',
  'shippingopts.table.r3c4': 'Tranquillité',
  'shippingopts.table.r4c1': 'Regroupée',
  'shippingopts.table.r4c2': 'Dépend',
  'shippingopts.table.r4c3': 'Peut être plus bas',
  'shippingopts.table.r4c4': 'Plusieurs articles',
  'shippingopts.s6.title': 'Suivre votre commande',
  'shippingopts.s6.p1': 'Utilisez le numéro de suivi pour suivre la progression et contactez le support par les canaux officiels en cas de retard.',
  'shippingopts.s6.p2': 'Conservez les numéros de suivi et les communications au cas où vous devriez faire un suivi.',
  'shippingopts.s7.title': 'Sécurité de l’expédition',
  'shippingopts.s7.p1': 'Fournissez les informations d’expédition uniquement sur des plateformes officielles et vérifiez l’adresse de destination.',
  'shippingopts.s7.p2': 'Méfiez-vous des demandes de changement de destination hors du processus officiel.',
  'shippingopts.conclusion.title': 'En résumé',
  'shippingopts.conclusion.p1': 'Comprendre vos options d’expédition aide à équilibrer coût, vitesse et fiabilité.',
  'shippingopts.conclusion.p2': 'Confirmez toujours les tarifs et délais actuels sur le site officiel avant de commander.',
  'shippingopts.cta': 'Explorer la boutique complète',
  'shippingopts.backHome': 'Retour à l’accueil',

  // ============ DISCOUNT CODE ============
  'discount.category': 'Réductions',
  'discount.shortTitle': 'Guide des codes promo USFans',
  'discount.readTime': '6 min de lecture',
  'discount.toc': 'Table des matières',
  'discount.h1': 'Guide des codes de réduction et codes promo USFans',
  'discount.lead': 'Apprenez comment fonctionnent les codes de réduction et codes promo, où les trouver et comment éviter les offres expirées ou suspectes.',
  'discount.s1.title': 'Comment fonctionnent les codes de réduction',
  'discount.s1.p1': 'Un code de réduction est un texte court saisi au paiement pour appliquer une remise, une promotion ou une offre spéciale.',
  'discount.s1.p2': 'Les codes peuvent être liés à des articles précis, à un montant minimum ou à une période ; leurs conditions varient.',
  'discount.s2.title': 'Où trouver des codes',
  'discount.s2.p1': 'Les canaux officiels, comme la boutique elle-même ou ses pages vérifiées, sont les plus fiables pour trouver les offres actuelles.',
  'discount.s2.p2': 'Confirmez toujours qu’un code est valide et actuel, car les offres changent fréquemment.',
  'discount.s3.title': 'Types de réductions',
  'discount.s3.p1': 'Les types courants incluent les remises en pourcentage, les réductions d’un montant fixe et les promotions de livraison gratuite.',
  'discount.s3.p2': 'Comprendre le type aide à estimer l’économie réelle et à comparer les offres équitablement.',
  'discount.s4.title': 'Éviter les codes expirés ou faux',
  'discount.s4.p1': 'Les codes peuvent expirer ou cesser de fonctionner ; testez-les au paiement et évitez les suspects.',
  'discount.s4.p2': 'Méfiez-vous des offres trop belles pour être vraies ou demandant de visiter des pages non officielles.',
  'discount.s5.title': 'Types de réductions comparés',
  'discount.s5.p1': 'Le tableau ci-dessous résume les types courants de réduction et ce qu’il faut vérifier pour chacun.',
  'discount.table.c1': 'Type',
  'discount.table.c2': 'Fonctionnement',
  'discount.table.c3': 'Idéal pour',
  'discount.table.c4': 'À vérifier',
  'discount.table.r1c1': 'Pourcentage',
  'discount.table.r1c2': 'Réduit d’un pourcentage',
  'discount.table.r1c3': 'Grosses commandes',
  'discount.table.r1c4': 'Montant minimum',
  'discount.table.r2c1': 'Montant fixe',
  'discount.table.r2c2': 'Réduit d’une valeur',
  'discount.table.r2c3': 'Toute commande',
  'discount.table.r2c4': 'Conditions et expiration',
  'discount.table.r3c1': 'Livraison gratuite',
  'discount.table.r3c2': 'Exonère l’expédition',
  'discount.table.r3c3': 'Économiser sur la livraison',
  'discount.table.r3c4': 'Conditions',
  'discount.table.r4c1': 'Lot',
  'discount.table.r4c2': 'Remise sur un ensemble',
  'discount.table.r4c3': 'Plusieurs articles',
  'discount.table.r4c4': 'Articles inclus',
  'discount.s6.title': 'Maximiser les économies',
  'discount.s6.p1': 'Comparez quelques offres actives, vérifiez les conditions et combinez les réductions uniquement si la boutique l’autorise.',
  'discount.s6.p2': 'Suivez les annonces officielles pour profiter des promotions tant qu’elles sont valides.',
  'discount.s7.title': 'Utilisation sécurisée des codes',
  'discount.s7.p1': 'Appliquez les codes uniquement au paiement officiel et ne partagez jamais vos données de paiement sur des pages non officielles.',
  'discount.s7.p2': 'Si un code demande des données personnelles ou vous redirige ailleurs, fermez la page et utilisez la boutique officielle.',
  'discount.conclusion.title': 'En résumé',
  'discount.conclusion.p1': 'Les codes de réduction et codes promo peuvent réduire votre total quand vous comprenez leurs conditions.',
  'discount.conclusion.p2': 'Utilisez les sources officielles et vérifiez les offres actuelles avant de payer.',
  'discount.cta': 'Explorer la boutique complète',
  'discount.backHome': 'Retour à l’accueil',

  // ============ BEGINNER GUIDE ============
  'beginner.category': 'Débutant',
  'beginner.shortTitle': 'Guide débutant USFans',
  'beginner.readTime': '8 min de lecture',
  'beginner.toc': 'Table des matières',
  'beginner.h1': 'Guide débutant USFans : démarrer étape par étape',
  'beginner.lead': 'Une introduction conviviale à USFans, couvrant les bases, le fonctionnement des ressources et un démarrage en toute sécurité.',
  'beginner.s1.title': 'Bienvenue sur USFans',
  'beginner.s1.p1': 'USFans est une ressource d’achat que beaucoup utilisent pour explorer produits, catégories et créateurs au même endroit.',
  'beginner.s1.p2': 'Ce guide explique l’essentiel pour que vous puissiez commencer à explorer en toute confiance.',
  'beginner.s2.title': 'Comprendre les bases',
  'beginner.s2.p1': 'Avant de naviguer, prenez un moment pour comprendre comment les ressources principales, comme le tableur et les répertoires, sont organisées.',
  'beginner.s2.p2': 'Une vision claire facilite tout le reste, de la recherche à la comparaison et au paiement.',
  'beginner.s3.title': 'Explorer les catégories',
  'beginner.s3.p1': 'Commencez par une catégorie qui vous intéresse, puis explorez les articles et créateurs qu’elle contient à votre rythme.',
  'beginner.s3.p2': 'Sur ce site, le menu des catégories et les boutons mènent directement aux sections correspondantes de la boutique principale.',
  'beginner.s4.title': 'Prendre votre première décision',
  'beginner.s4.p1': 'Comparez quelques options, vérifiez les détails d’expédition et lisez les guides pertinents avant votre premier choix.',
  'beginner.s4.p2': 'Rien ne presse : prendre le temps de comprendre vos options mène à de meilleures décisions.',
  'beginner.s5.title': 'Premiers pas comparés',
  'beginner.s5.p1': 'Le tableau ci-dessous associe les premiers pas courants aux ressources qui aident à chacun.',
  'beginner.table.c1': 'Étape',
  'beginner.table.c2': 'Que faire',
  'beginner.table.c3': 'Guide utile',
  'beginner.table.c4': 'Conseil clé',
  'beginner.table.r1c1': 'Apprendre les bases',
  'beginner.table.r1c2': 'Lire une introduction',
  'beginner.table.r1c3': 'Ce guide',
  'beginner.table.r1c4': 'Allez-y doucement',
  'beginner.table.r2c1': 'Parcourir les catégories',
  'beginner.table.r2c2': 'Choisir une catégorie',
  'beginner.table.r2c3': 'Menu des catégories',
  'beginner.table.r2c4': 'Commencez large',
  'beginner.table.r3c1': 'Comparer les options',
  'beginner.table.r3c2': 'Consulter les articles',
  'beginner.table.r3c3': 'Tableaux comparatifs',
  'beginner.table.r3c4': 'Notez les différences',
  'beginner.table.r4c1': 'Vérifier l’expédition',
  'beginner.table.r4c2': 'Confirmer les coûts',
  'beginner.table.r4c3': 'Guide d’expédition',
  'beginner.table.r4c4': 'Vérifier officiel',
  'beginner.s6.title': 'Erreurs courantes des débutants',
  'beginner.s6.p1': 'Se précipiter, sauter les détails d’expédition et ignorer les bases de la sécurité sont des erreurs courantes.',
  'beginner.s6.p2': 'Ralentir, vérifier les informations et utiliser les canaux officiels aide à éviter la plupart des problèmes.',
  'beginner.s7.title': 'Rester en sécurité en tant que débutant',
  'beginner.s7.p1': 'Utilisez des mots de passe forts, ne payez que par des canaux officiels et méfiez-vous des liens ou offres inconnus.',
  'beginner.s7.p2': 'Cette ressource indépendante est gratuite et ne demande pas vos informations personnelles.',
  'beginner.conclusion.title': 'En résumé',
  'beginner.conclusion.p1': 'Démarrer avec USFans est simple une fois que vous comprenez les bases et avancez étape par étape.',
  'beginner.conclusion.p2': 'Utilisez les guides, explorez les catégories et vérifiez toujours les détails importants par vous-même.',
  'beginner.cta': 'Explorer la boutique complète',
  'beginner.backHome': 'Retour à l’accueil',
};